import { setTag, setContext } from "@sentry/browser";
import type { ConsentSnapshot } from "./cookiebotConsentSnapshot";

export function applySentryConsent(snapshot: ConsentSnapshot): void {
  setTag("cookie_consent_necessary", snapshot.necessary);
  setTag("cookie_consent_preferences", snapshot.preferences);
  setTag("cookie_consent_statistics", snapshot.statistics);
  setTag("cookie_consent_marketing", snapshot.marketing);
  setContext("cookie_consent", { ...snapshot });
}
